import { formatDate } from '$utils/filters'

export default [
  {
    label: '交易金额',
    key: 'trade_balance',
    format: (val: number) => {
      return val ? `${val}香蕉贝` : ''
    },
    shouldFormat: true
  },
  {
    label: '交易时间',
    key: 'trade_finish_time',
    format: (val: number) => {
      return formatDate(val, 'YYYY-MM-DD HH:mm:ss')
    },
    shouldFormat: true
  },
  {
    label: '交易单号',
    key: 'trade_order_no',
    format: null,
    shouldFormat: false
  },
  {
    label: '交易类型',
    key: 'order_type',
    format: (val: string) => {
      let desc = ''
      switch (val) {
        case '1':
          desc = '神象云普惠套餐（1个月）'
          break
        case '2':
          desc = '神象云普惠套餐（3个月）'
          break
        case '3':
          desc = '神象云普惠套餐（1年）'
          break
        default:
          break
      }
      return desc
    },
    shouldFormat: true
  },
  {
    label: '备注',
    key: 'remark',
    format: null,
    shouldFormat: false
  }
]
